import React from "react"
import moment, {Moment} from "moment";
import {Col, DatePicker} from "antd";
import {Label} from "../../../../../common/Label/Label";
import styles from "../../../Style/DatasetInfo.module.scss"
import {copyDefaultTimeRange} from "../../../../../../utils/dateRange";

// Helper function to convert date strings to Moment objects
const ensureMoment = (date: string | Moment | null): Moment | null => {
  if (!date) return null;
  return typeof date === 'string' ? moment(date) : date;
};

export const DateRangeSelector = ({
  id,
  dateRange,
  disabledDate,
  onDateChange,
  isDisabled
}: {
  id: string;
  dateRange?: [string | Moment, string | Moment] | [string, string] | [Moment, Moment];
  disabledDate: (current: Moment) => boolean;
  onDateChange: (value: any) => void;
  isDisabled: boolean;
}) => {
  const momentDateRange = dateRange ? [
    ensureMoment(dateRange[0]),
    ensureMoment(dateRange[1])
  ] as [Moment, Moment] : undefined;

  // TODO: Find the correct types for dates Antd
  const handleDateChange = (dates: any) => {
    if (dates && dateRange) {
      const updatedDates = [
        copyDefaultTimeRange(
          ensureMoment(dateRange[0]) as Moment,
          dates[0]
        ),
        copyDefaultTimeRange(
          ensureMoment(dateRange[1]) as Moment,
          dates[1]
        )
      ]
      onDateChange(updatedDates)
    }
  }

  return (
    <Col span={12}>
      <Label
        label={
          <div className={styles.DateLabel}>
            <span style={{ flexBasis: '50%' }}>Start Date</span>
            <span>End Date</span>
          </div>
        }
      >
        <DatePicker.RangePicker
          id={id}
          value={momentDateRange}
          disabledDate={disabledDate}
          format={['YYYY-MM-DD', 'YYYY-MM-DD']}
          style={{ width: '100%' }}
          onChange={handleDateChange}
          disabled={isDisabled}
        />
      </Label>
    </Col>
  );
};
